// extracted by mini-css-extract-plugin
module.exports = {"leave-message":"leave-message__dpvb0","leave-message__main":"leave-message__main__Nh8hu","leave-message__message":"leave-message__message__h7okE"};